// Vuex module for storing the current carbon credit project data
export default {
  namespaced: true,
  state: {
    currentProject: null,
    draftProject: null, // Draft from Register (new project) for submitting on View Confirm
  },
  mutations: {
    SET_CURRENT_PROJECT(state, project) {
      state.currentProject = project;
    },
    CLEAR_CURRENT_PROJECT(state) {
      state.currentProject = null;
    },
    SET_DRAFT_PROJECT(state, draft) {
      state.draftProject = draft;
    },
    CLEAR_DRAFT_PROJECT(state) {
      state.draftProject = null;
    },
  },
  actions: {
    setCurrentProject({ commit }, project) {
      commit('SET_CURRENT_PROJECT', project);
    },
    clearCurrentProject({ commit }) {
      commit('CLEAR_CURRENT_PROJECT');
    },
    setDraftProject({ commit }, draft) {
      commit('SET_DRAFT_PROJECT', draft);
    },
    clearDraftProject({ commit }) {
      commit('CLEAR_DRAFT_PROJECT');
    },
  },
  getters: {
    currentProject: (state) => state.currentProject,
    draftProject: (state) => state.draftProject,
  },
}; 